import { render, staticRenderFns } from "./BaseListItemPicker.vue?vue&type=template&id=3a61e6f7&scoped=true&"
import script from "./BaseListItemPicker.vue?vue&type=script&lang=js&"
export * from "./BaseListItemPicker.vue?vue&type=script&lang=js&"
import style0 from "./BaseListItemPicker.vue?vue&type=style&index=0&id=3a61e6f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a61e6f7",
  null
  
)

export default component.exports